import templateUrl from "emun.cart/cart-item-quick-view.htm";
import 'emun.cart/cart-item-quick-view.client.scss';

export default () => ({
  templateUrl
});
